import { useTippingCardForm } from "@/components/shared/forms/tipping-card-form";
import type { CommonColor } from "@stackje/common/config";

export function AddTippingCard(_defaultType: "tipping1" | "tipping2", defaultColors: CommonColor) {
  // Force tipping1 for now, regardless of defaultType parameter
  const { formContent, previewContent, shuffleColors, toggleType, handleSubmit } = useTippingCardForm({
    initialData: {
      title: "",
      description: "",
      paymentMethod: "paynow",
      payeeInfo: {
        paynow: {
          type: "MOBILE",
          value: "",
          recipientName: "",
        }
      },
      amounts: [5, 10, 20, 50],
      allowCustomAmount: true,
      minAmount: 1,
      maxAmount: 999,
      currency: "SGD",
      buttonText: "Generate QR Code",
      thankYouNote: "Thank you for your support! 🙏",
      type: "tipping1", // Always use tipping1 for now
      colors: defaultColors,
    },
    mode: "add",
  });

  return {
    formContent,
    previewContent,
    shuffleColors,
    toggleType,
    handleSubmit,
  };
}